import BaseComponent from "../core/base-component.js";

export default class ContentElement extends BaseComponent {

}
